export default {
  de: {
    info: 'Info',
    documents: 'Redaktion',
    postings: 'Social Media',
    users: 'Benutzer',
    settings: 'Einstellungen',
  },
};
